import React from "react";

// SVG logo: outer hexagonal frame (physical) + inner smaller frame (digital twin)
// connected by thin lines to represent the digital-twin concept.
export default function DigiTwinLogo({ size = 24, color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="DigiTwin"
    >
      {/* Outer hexagon — the physical model */}
      <polygon
        points="16,2 28,9 28,23 16,30 4,23 4,9"
        strokeWidth="1.8"
        opacity="1"
      />
      {/* Inner hexagon — the digital twin */}
      <polygon
        points="16,9 22,12.5 22,19.5 16,23 10,19.5 10,12.5"
        strokeWidth="1.2"
        opacity="0.55"
      />
      {/* Connecting lines (physical ↔ digital) */}
      <line x1="4"  y1="9"  x2="10" y2="12.5" strokeWidth="0.8" opacity="0.35" />
      <line x1="28" y1="9"  x2="22" y2="12.5" strokeWidth="0.8" opacity="0.35" />
      <line x1="4"  y1="23" x2="10" y2="19.5" strokeWidth="0.8" opacity="0.35" />
      <line x1="28" y1="23" x2="22" y2="19.5" strokeWidth="0.8" opacity="0.35" />
      <line x1="16" y1="2"  x2="16" y2="9"    strokeWidth="0.8" opacity="0.35" />
      <line x1="16" y1="30" x2="16" y2="23"   strokeWidth="0.8" opacity="0.35" />
    </svg>
  );
}
